<template>
  <div
    class="d-flex lpg-jobposting-card align-items-center card-shadow my-3"
    @click="$emit('click', jobposting.id)"
  >
    <img src="/images/bolsa-img.png" class="img-fluid d-none d-lg-block col-lg-2" />
    <div class="lpg-jobposting-content p-3 col-12 col-lg-10">
      <p class="fs-5 fw-bold my-0">{{ jobposting.title }}</p>
      <p class="fs-6 text-secondary my-0">{{ jobposting.category }}</p>
      <p class="fs-6 text-white my-0">{{ jobposting.short_description }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'JobPostingCard',
  props: {
    jobposting: {
      type: Object,
      required: true,
      validator: toValidate => {
        // Value (object) must have all of these keys
        const required = {
          id: 'number',
          title: 'string',
          category: 'string',
          short_description: 'string',
        }

        return Object.entries(required).every(([key, value]) => typeof toValidate[key] === value)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
img {
  border-radius: 10px;
}

.lpg-jobposting-card {
  background: #1b262c;
  color: #a7d129;
  border-radius: 10px;
  // white-space: nowrap;
}

.card-shadow {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

.card-shadow:hover {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}
</style>
